export const AutofillStatus = {
  NotStarted: 'not_started',
  InProgress: 'in_progress',
  Unknown: 'unknown',
  NotAvailable: 'not_available'
} as const

export type AutofillStatusValue = (typeof AutofillStatus)[keyof typeof AutofillStatus]

export type AutofillStatusData = {
  status: AutofillStatusValue
  lastUpdatedAt: string | null
}
